<div class="td-loading-container" *ngIf="loadingSpinner">
  <mat-spinner class="td-loading"></mat-spinner>
</div>
<ng-container *ngIf="!showForgotPassword">
  <form [formGroup]="tdLoginForm">
    <div class="td-form-row">
      <mat-form-field class="td-full-form">
        <mat-label>
          <fa-icon icon="user"></fa-icon>
          Username
        </mat-label>
        <input matInput formControlName="tdUsername" required type="email" aria-label="Username" autofocus>
      </mat-form-field>
    </div>
    <div class="td-form-row">
      <mat-form-field class="td-full-form">
        <mat-label>
          <fa-icon icon="lock"></fa-icon>
          Password
        </mat-label>
        <input matInput formControlName="tdPassword"  [type]="hidePassWord ? 'password' : 'text'" required aria-label="Password">
        <button mat-icon-button type="button" matSuffix (click)="hidePassWord = !hidePassWord" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassWord">
          <mat-icon>{{hidePassWord ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div class="td-form-row td-pw-hint-container" *ngIf="passwordErrorMsg">
      <span class="td-pw-hint">Password Reminder Hint:</span>
      <ul class="td-pw-hint">
        <li *ngIf="loginRegistrationOptions.passwordMinCharLength > 0">
          Password requires a min. length of {{loginRegistrationOptions.passwordMinCharLength}}
        </li>
        <li *ngIf="loginRegistrationOptions.requirePasswordCharacter">
          Password requires special character
        </li>
        <li *ngIf="loginRegistrationOptions.requirePasswordNumber">
          Password requires number
        </li>
        <li *ngIf="loginRegistrationOptions.requirePasswordMixedCase">
          Password required the use of Uppercase and Lowercase characters
        </li>
      </ul>
    </div>
    <div class="td-form-row">
      <mat-checkbox [checked]="setUsernameLocal(tdLoginForm.get('tdRememberUsername').value)" class="td-center-align" formControlName="tdRememberUsername">Remember Username?</mat-checkbox>
    </div>

    <button mat-flat-button class="td-form-login-button" type="submit" 
      [style.background-color]="tdLoginForm.invalid ? null : primaryColor" 
      (click)="userLogin(tdLoginForm.get('tdUsername').value, tdLoginForm.get('tdPassword').value)" 
      [disabled]="tdLoginForm.invalid || loadingSpinner" aria-label="Login">Login</button>
  </form>
  <div><button mat-button class="td-forgot-password-button" (click)="userForgotPassword()" aria-label="Forgot your password?">Forgot your password?</button></div>
</ng-container>
<ng-container *ngIf="showForgotPassword">
  <form [formGroup]="forgottenPassword">
    <mat-form-field style="width:75%;" >
      <mat-label>
        <fa-icon icon="envelope"></fa-icon>
        Email Address
      </mat-label>
      <input matInput formControlName="tdEmailUser" required type="email" aria-label="Email Address" autofocus>
    </mat-form-field>
    <div class="td-password-reset-form-buttons">
      <button mat-flat-button class="td-form-back-button" [style.background-color]="primaryColor" (click)="backToLogin()" aria-label="Go back to login form">Back</button>
      <button mat-flat-button class="td-form-reset-button" [style.background-color]="forgottenPassword.invalid ? null : primaryColor" [disabled]="forgottenPassword.invalid" (click)="submitForgotPassword(forgottenPassword.get('tdEmailUser').value)" aria-label="Submit">Submit</button>
    </div>    
  </form>
</ng-container>